export default {
    createCourse:
        "/gateway/huilianOperation/coursecs/createCourse?activity=365", //课程详情
    commitCourse:
        "/gateway/huilianOperation/learningResultcs/commitCourse?activity=365", //课程结束提交
    selectCourseDetail:
        "/gateway/huilianOperation/coursecs/selectCourseDetail?activity=365", // 课程详情
};



// WEBPACK FOOTER //
// ./src/safetyTrainingCourses/index/api.js